<div class="wrapper">
  <app-header [siteUpdateDate]="siteUpdateDate"></app-header>

  <main role="main" id="main">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>
